import React, { useEffect, useState, Fragment } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const getRandomData = () => new Array(7).fill(0).map(() => Math.floor(Math.random() * 100));

const getState = (dataIndicador) => {
  let resumeIndicator = {
    labels: getFilterNamesData(dataIndicador),
    datasets: [
      {
        label: 'Resumen Rechazadas',
        backgroundColor: '#55e5bb',
        borderColor: '#55e5bb',
        borderWidth: 1,
        hoverBackgroundColor: '#55e5bb',
        hoverBorderColor: '#55e5bb',
        data: getRejectsDataNumber(dataIndicador),
      },
    ],
  }
  return resumeIndicator;
};

const options = {
  legend: {
    position: 'bottom',
    scales: {
      x: {
        ticks: {
          maxRotation: 0,
          minRotation: 0
        }
      },
      y: {
        ticks: {
          maxRotation: 0,
          minRotation: 0
        }
      }
    }
  }
};

const getFilterNamesData = (dataIndicator) => {
  let arrMes = [];
  for (let i = 0; i < dataIndicator.length; i++) {
    let mes = `${dataIndicator[i].mes}`;
    arrMes.push(mes);
  }
  return arrMes;
}

const getRejectsDataNumber = (dataIndicator) => {
  let arrDataNumber = [];
  for (let i = 0; i < dataIndicator.length; i++) {
    arrDataNumber.push(dataIndicator[i].rechazados);
  }
  return arrDataNumber;
}

const AnimatedBarMontlyRejecteds = ({ dataIndicator }) => {

  const [data, setData] = useState(null);

  useEffect(() => {
    getDataIndicator(dataIndicator);
  }, []);

  const getDataIndicator = async (dataIndicator) => {
    let dataInd = await getState(dataIndicator);
    setData(dataInd);
  }

  return (
    <Fragment>
      {data != null ? <Bar data={data} options={options} /> : null}
    </Fragment>
  );
};

export default AnimatedBarMontlyRejecteds;
